import { createSlice } from "@reduxjs/toolkit";

interface InvoiceInitialStateModel {
  filter:any;
}
const invoiceInitialState: InvoiceInitialStateModel = {
  filter:{
    PageIndex:1,
    PageSize:20,
    SortProperty:"InsertDate",
    SortType:"desc",
    IncludeProperties:["PaymentStatus","User.UserPackage.Package"]
  }
};

const invoiceSlice = createSlice({
  name: "invoiceSlice ",
  initialState: invoiceInitialState,
  reducers: {
    handleSetInvoiceFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleResetInvoiceFitler: (state, ) => {
      state.filter = {
        PageIndex:1,
        PageSize:20,
        SortProperty:"InsertDate",
        SortType:"asc",
        IncludeProperties:["PaymentStatus"]
      };
    },
   
   
    
  },
});

export const {
  handleSetInvoiceFilter,
  handleResetInvoiceFitler,
} = invoiceSlice.actions;
export default invoiceSlice;
